import { StrictMode } from "react";
import { createRoot } from "react-dom/client";

// KaTeX's stylesheet also carries the Computer Modern webfonts that the whole
// interface is set in, so this import is typography, not just math.
import "katex/dist/katex.min.css";
import "./styles/index.css";

import { App } from "./App.tsx";
import { AuthGate } from "./components/AuthGate.tsx";
import { ThemeProvider } from "./theme.tsx";
import { ReadingProvider } from "./reading.tsx";
import { TooltipProvider } from "./components/ui/tooltip.tsx";

const container = document.getElementById("root");
if (!container) throw new Error("#root is missing from index.html");

createRoot(container).render(
  <StrictMode>
    <ThemeProvider>
      <ReadingProvider>
      {/* Radix shares one open-tooltip timer across the tree, so the second
          hover in a row opens immediately rather than re-serving the delay. */}
      <TooltipProvider delayDuration={350}>
        <AuthGate>
          <App />
        </AuthGate>
      </TooltipProvider>
      </ReadingProvider>
    </ThemeProvider>
  </StrictMode>,
);
